'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "max", "min", "numberInputProps", "numberInputWidth", "onChange", "readOnly", "value"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import UISlider from '../input/UISlider';
import UINumberInput from '../input/UINumberInput';
import Controllable from '../decorators/Controllable';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class UISliderInput extends Component {
  render() {
    const _this$props = this.props,
      {
        disabled,
        max,
        min,
        numberInputProps,
        numberInputWidth,
        onChange,
        readOnly,
        value
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsxs("div", {
      className: "private-slider__input",
      children: [/*#__PURE__*/_jsx(UINumberInput, Object.assign({
        className: "private-slider__number-input",
        disabled: disabled,
        max: max,
        min: min,
        value: value,
        onChange: onChange,
        readOnly: readOnly,
        style: {
          width: numberInputWidth
        }
      }, numberInputProps)), /*#__PURE__*/_jsx(UISlider, Object.assign({
        disabled: disabled,
        max: max,
        min: min,
        value: value,
        onChange: onChange,
        readOnly: readOnly
      }, rest))]
    });
  }
}
UISliderInput.displayName = 'UISliderInput';
UISliderInput.defaultProps = UISlider.defaultProps;
UISliderInput.propTypes = Object.assign({}, UISlider.propTypes, {
  defaultValue: PropTypes.number,
  numberInputProps: PropTypes.object,
  numberInputWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.number
});
export default Controllable(UISliderInput);